<template>
  <div>
    <el-upload
      class="upload-demo"
      :drag="isType === 'drag'"
      :action="getAction"
      :multiple="multiple"
      :headers="getHeaders"
      :on-remove="deleteFile"
      :on-success="onSuccess"
      :file-list="getFileList"
      :disabled="disabled"
      :listType="getListType"
      :limit="limit"
      :on-preview="handlePictureCardPreview"
      :before-upload="beforeUpload"
      :show-file-list="showFileList && !hideList"
      :accept="accept"
    >
      <template #tip>
        <div v-if="isType === 'drag'" class="el-upload__tip">
          可支持Excel、PDF、word、JPG、PNG等多种格式
        </div>
        <span v-else></span>
      </template>

      <template #default>

        <p
          v-if="isType === 'add' && limit !== 1 && !disabled"
          class="iconfont icon-jiahao"
          style="font-size: 50px; color: #dddddd;"
        ></p>
        <p v-else-if="disabled" style=" color: #dddddd;">您不能上传文件</p>

        <div class="up-img" v-else-if="isType === 'add' && limit === 1">
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <p
            :style="{ fontSize: iconSize + 'px' }"
            :class="['iconfont', icon]"
            v-else
          ></p>
        </div>
        <div v-else>
          <i class="iconfont icon-yunshangchuan"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </div>
      </template>
    </el-upload>
    <el-dialog
	width="30%"
	v-model="dialogVisible"
	center
	>
	<div >
    <div class="view_area" id="viewPic">
      <el-image width="100%" class="content" :src="dialogImageUrl" alt="" fit="contain" >
      </el-image>
      <img v-show="stampShow" class="chapter" :src="img" />
    </div>
    <div style="margin-top: 10px; text-align: right; padding-bottom: 15px; padding-right: 15px; border-top: 1px solid rgb(91 91 91);">
      <el-button style="margin-top: 15px; margin-left: 15px; " v-if="dialogImageUrl" @click="downLoadFile(dialogImageUrl)"  size="small"
                      class="change-btn"
                      type="danger"
                      plain  >下载附件</el-button>
      <el-button v-show="isStamp && disabled" style="margin-top: 15px; margin-left: 15px; " v-if="dialogImageUrl" @click="stamp()"  size="small"
                      class="change-btn"
                      type="danger"
                      plain  >盖章</el-button>
      <el-button v-show="isStamp && disabled" :disabled="!hasStamp" style="margin-top: 15px; margin-left: 15px; " v-if="dialogImageUrl" @click="saveStampResult()"  size="small"
                      class="change-btn"
                      type="danger"
                      plain  >确认</el-button>
    </div>
	</div>
    </el-dialog>
  </div>
</template>

<script>
import html2Canvas from "html2canvas";
import request from "@/common/js/request.js";
import api from "@/common/js/api.js";
import { mapState } from "vuex";
import { ElMessage, ElMessageBox } from "element-plus";
import { uploadFileOnSuccess } from "@/common/js/uploadFile.js";
import { getBase64 } from "@/common/js/common.js";
import { downLoadFile } from "@/common/js/common.js";


export default {
  data() {
    return {
      fileList: [],
      imageUrlCopy: "",
      dialogVisible: false,
      dialogImageUrl: "",
      stampShow: false,
      hasStamp: false,
      rejectedFileUids: [],
    };
  },
  props: {
    modelValue: {
      //绑定的id
      type: Array,
      default: () => {
        return [];
      },
    },
    list: {
      //上传的文件列表
      type: Array,
      default: () => {
        return [];
      },
    },
    isType: {
      type: String,
      default: "drag",
    },
    multiple: {
      //是否多选
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    listType: {
      type: String,
      default: "",
    },
    limit: {
      type: Number,
      default: 1,
    },
    icon: {
      type: String,
      default: "icon-jiahao",
    },
    iconSize: {
      type: Number,
      default: 28,
    },
    /** 是否显示已上传文件列表 很多地方都是true,不需要就设置为false */
    showFileList: {
      type: Boolean,
      default: true,
    },
    img:{
      type: String,
      default: ""
    },
    isStamp:{
      type: [Boolean, String],
      default: false
    },
    autoFill:{

    },
    maxSizeMb: {
      type: Number,
      default: 0,
    },
    accept: {
      type: String,
      default: "",
    },
    onlyImage: {
      type: Boolean,
      default: false,
    },
    allowedMimeTypes: {
      type: Array,
      default: () => [],
    },
    invalidFileTypeMessage: {
      type: String,
      default: "",
    },
    afterSuccess: {
      type: Function,
      default: null,
    },
    afterDelete: {
      type: Function,
      default: null,
    }
  },
  computed: {
    ...mapState([
      "token", //获取token
    ]),
    getAction() {
      //上传文件地址
      return request.defaults.baseURL + api.uploadFile + "?fileType=CUSTOMER";
    },
    getHeaders() {
      //请求头部
      return {
        Authorization: this.token || null,
      };
    },
    hideList() {
      return this.limit === 1 && this.isType === "add";
    },
    imageUrl() {
      return this.imageUrlCopy
        ? this.imageUrlCopy
        : this.hideList && this.fileList.length
        ? this.fileList[0].url
        : "";
    },
    getListType() {
      return this.hideList ? "text" : this.listType;
    },
    getFileList() {
      return this.hideList ? [] : this.fileList;
    },
  },
  methods: {
    getUploadFileId(file) {
      if (!file) return "";
      if (file.fileId) return file.fileId;
      if (file.data && file.data.fileId) return file.data.fileId;
      if (file.response && file.response.fileId) return file.response.fileId;
      if (file.response && file.response.data && file.response.data.fileId) return file.response.data.fileId;
      if (file.response && file.response.data && file.response.data.data && file.response.data.data.fileId) {
        return file.response.data.data.fileId;
      }
      return "";
    },
    beforeUpload(file) {
      if (this.onlyImage && !file.type.startsWith("image/")) {
        ElMessage.warning("只能上传图片文件");
        return false;
      }
      if (this.allowedMimeTypes.length && !this.allowedMimeTypes.includes(file.type)) {
        const message = this.invalidFileTypeMessage || "请上传PNG格式的图片";
        this.rejectedFileUids.push(file.uid);
        if (this.invalidFileTypeMessage) {
          ElMessageBox.alert(message, "文件格式不正确", {
            confirmButtonText: "知道了",
            type: "warning",
          }).catch(() => {});
        }
        return false;
      }
      if (this.maxSizeMb && file.size / 1024 / 1024 > this.maxSizeMb) {
        ElMessage.warning(`上传文件不能超过${this.maxSizeMb}M`);
        return false;
      }
      return true;
    },
    resetStampState() {
      this.stampShow = false;
      this.hasStamp = false;
    },
    stamp(){
      if (!this.img) {
        ElMessage.warning("请先维护企业合同章后再盖章");
        return;
      }
      this.stampShow = true;
      this.hasStamp = true;
    },
    downLoadFile,
    async handlePictureCardPreview(file) {
      this.resetStampState();
      this.dialogImageUrl = file.url;
      if(this.dialogImageUrl.startsWith("http")){
          this.dialogImageUrl = await this.getBas64(this.dialogImageUrl)
      }
      this.dialogVisible = true;
    },
    deleteFile(file, fileList) {
      //删除文件的回调
      if (this.rejectedFileUids.includes(file.uid)) {
        this.rejectedFileUids = this.rejectedFileUids.filter(uid => uid !== file.uid);
        return;
      }
      if (!fileList.length) {
        this.imageUrlCopy = "";
      }
      this.fileList = [...fileList];
      this.$emit("delete", fileList);
      if (this.afterDelete) {
        this.afterDelete(file, fileList);
      }
    },
    onSuccess(res, file, fileList) {
      //上传成功的回调
      uploadFileOnSuccess(res, file, fileList)
        .then((res) => {
          getBase64(file.raw).then((res) => {
            this.imageUrlCopy = res;
          });
          this.fileList = [...fileList];
          const fileId = this.getUploadFileId(file.response) || this.getUploadFileId(file);
          this.$emit("update:modelValue", fileId ? [fileId] : []);
          var info = JSON.parse(JSON.stringify(file.response.data));
          this.$emit("usuccess", info, fileList); //上传成功后的回调
          if (this.afterSuccess) {
            this.afterSuccess(info, fileList);
          }
        })
        .catch((res) => {
          this.fileList = [...this.fileList];
        });
    },
    saveStampResult(){
      if (!this.img) {
        ElMessage.warning("请先维护企业合同章后再盖章");
        return;
      }
      if (!this.hasStamp) {
        ElMessage.warning("请先点击盖章");
        return;
      }
      var title = "货物购销合同";
      var that = this;
      html2Canvas(document.querySelector("#viewPic"), {
        allowTaint: true,
      }).then(function (canvas) {
        canvas.toBlob(blob => {
          const file = new File([blob], title+".png", { type: 'image/png' });
          that.uploadToServer(file);
          that.dialogVisible = false;
        });
      });

    },
    getBas64(url, outputFormat = "image/png") {
      return new Promise(function (resolve, reject) {
        let canvas = document.createElement("CANVAS"),
          ctx = canvas.getContext("2d"),
          img = new Image();
        img.crossOrigin = "Anonymous"; // 重点！设置image对象可跨域请求
        img.onload = function () {
          canvas.height = img.height;
          canvas.width = img.width;
          ctx.drawImage(img, 0, 0);
          let dataURL = canvas.toDataURL(outputFormat);
          canvas = null;
          resolve(dataURL);
        };
        // img.src = url; // 旧的方式
        img.src = url + "?t=" + new Date().valueOf(); // 防止oss的缓存问题
      });
    },
    uploadToServer(file) {
      let that = this;
      const formData = new FormData();
      formData.append('file', file);
      axios.post(request.defaults.baseURL + api.uploadFile + "?fileType=CUSTOMER", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer ' + sessionStorage.getItem("token") // 可选
        }
      }).then(response => {
        console.log('上传成功:', response.data);
        that.$emit("autoFill", response.data)
      }).catch(error => {
        console.error('上传失败:', error);
      });
    },
  },
  created() {
    this.fileList = this.list;
  },
  watch: {
    fileList(v) {
      var arr = [];
      v.map((item) => {
        const fileId = this.getUploadFileId(item);
        if (fileId) {
          arr.push(fileId);
        }
      });
      this.$emit("update:modelValue", arr);
    },
    list: {
      deep: true,
      handler: function(v) {
        const res = new Map();
        var arr = v.filter(
          (item) => !res.has(item.fileId) && res.set(item.fileId, 1)
        );
        this.fileList = arr;
      },
    },
    dialogVisible(v) {
      if (!v) {
        this.resetStampState();
      }
    }
  },
};
</script>

<style scoped lang="less">
.upload-demo {
  .el-upload-list {
    float: right;
  }
  .icon-yunshangchuan {
    font-size: 50px;
    margin-top: 40px;
    display: inline-block;
    color: #999999;
  }
}
.up-img {
  width: 148px;
  height: 148px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fbfdff;
  border-radius: 10px;
  border: 1px solid #eeeeee;
  overflow: hidden;
  box-sizing: border-box;
  p {
    font-size: 28px;
    color: #999999;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.view_area {
      display: flex;
      align-items: center;
      padding-top: 30px;
      position: relative;
      margin: 0 auto;

      .content {
        flex: 1;
        position: relative;

      }
      .chapter {
          position:absolute;
          width: 210px;
          right: 0%;
          bottom: 20px;
          transform: translateX(-50%);
          z-index: 20;
      }
}
</style>
